import React, { useState, useRef, useEffect, useContext, useMemo, useCallback } from "react";
import { formatPriceWithSymbol } from '../../utils/currency';
import '../ListCategoria/style.css';
import './style.css';
import '../../styles/page-titles.css';
import styled from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getStoredUser } from '../../utils/safeStorage';

import { SidebarContext } from "../../AppRoutes";
import { getAdicionais, deleteGrupoAdicional, deleteItemAdicional, updateItemAdicionalOut, updateItemAdicionalOutSalao, duplicateGrupoAdicional, updateAdicionaisItemOrder } from "../../services/api";

import PermissionGate from "../../services/PermissionGate";

import { useNavigate } from "react-router-dom";

import ConfirmDialog from "../../components/ConfirmDialog";

import { toast } from "react-toastify";
import Loading from "react-loading";
import { MdFastfood } from "react-icons/md";
import SafeImage from "../../components/SafeImage";
import { FiSearch, FiCopy } from 'react-icons/fi';
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { BsPlusCircle } from "react-icons/bs";
import { IoGridOutline } from "react-icons/io5";
import { SlRefresh } from 'react-icons/sl';
import { TbDotsVertical } from "react-icons/tb";
import { AiOutlineMenu } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

import ModalEditGrupoAdicionais from "../../components/ModalEditGrupoAdicionais";
import ModalEditItemAdicional from "../ListCategoria/ModalEditItemAdicional";
import ModalRegisterItemAdicional from "../ListCategoria/ModalRegisterItemAdicional";
import ModalAddGroupAdicionais from "../ListItem/ModalAddGroupAdicionais";

const PageContainer = styled.div`
    display: flex;
    margin-left: ${({ sidebar }) => (sidebar ? '250px' : '100px')};
    min-height: 100vh;
    width: auto;
    transition: margin-left 220ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
    background: #FFF;
    overflow: initial;
    z-index: 9;
    padding: 28px 32px;
    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

    @media (max-width: 880px) {
        margin-left: 0;
        padding: 16px;
    }
`;

const ListAdicional = ({ list = [] }) => {
    const { t } = useTranslation('complementos');

    const userParse = getStoredUser();
    const userID = userParse?._id;
    const empresa = localStorage.getItem('empresa');
    const empresaParse = JSON.parse(empresa);
    const idEmpresa = empresaParse.id_empresa;

    const navigate = useNavigate();
    const { sidebar } = useContext(SidebarContext);

    const [adicionais, setAdicionais] = useState([]);
    const [filter, setFilter] = useState('');
    const [loading, setLoading] = useState(true);
    const [refresh, setRefresh] = useState(false);

    const [showEditGrupoAdicionais, setShowEditGrupoAdicionais] = useState(false);
    const [categoriaToEdit, setCategoriaToEdit] = useState(null);

    const [visibleDropdown, setVisibleDropdown] = useState(null);
    const dropdownRef = useRef(null);

    // Modal de editar item adicional
    const [showEditItemAdicional, setShowEditItemAdicional] = useState(false);
    const [itemAdicionalToEdit, setItemAdicionalToEdit] = useState(null);
    const [idGrupoToEdit, setIdGrupoToEdit] = useState(null);
    const [typeGrupoToEdit, setTypeGrupoToEdit] = useState("simples");

    // Modal de cadastrar item adicional
    const [showRegisterItemAdicional, setShowRegisterItemAdicional] = useState(false);
    const [idGrupoToRegister, setIdGrupoToRegister] = useState(null);
    const [typeAdicional, setTypeAdicional] = useState(null);

    // Modal de adicionar grupo
    const [showModalAddGroupAdd, setShowModalAddGroupAdd] = useState(false);
    const [selectDataAdicionais, setSelectDataAdicionais] = useState([]);
    const [tempAdicionais, setTempAdicionais] = useState([]);

    // Confirmação de delete
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [shouldDelete, setShouldDelete] = useState(false);
    const [idToDelete, setIdToDelete] = useState('');

    // ──────────── Data Fetch ────────────
    useEffect(() => {
        (async () => {
            const response = await getAdicionais();
            setAdicionais(response.data.adicionais);
            setLoading(false);
            setRefresh(false);
        })();
    }, [refresh]);

    // ──────────── Click Outside ────────────
    const handleClickOutside = useCallback((event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setVisibleDropdown(null);
        }
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [handleClickOutside]);

    // ──────────── Lista filtrada/ordenada ────────────
    const displayList = useMemo(() => {
        const sorted = [...adicionais].sort((a, b) => a.order - b.order);
        if (!filter) return sorted;
        const sanitized = filter.replace(/[^\d\w]+/g, '.*');
        const exp = new RegExp(sanitized, 'i');
        return sorted.filter(item => exp.test(item.title));
    }, [adicionais, filter]);

    // ──────────── Handlers ────────────
    const handleFilter = (e) => setFilter(e.target.value);
    const handleRefresh = () => { setLoading(true); setRefresh(true); };

    // Reordenar adicionais (sub-itens) dentro de um grupo via drag-and-drop (Tipo B)
    const handleDragEndAdicional = useCallback((grupoId, result) => {
        const { source, destination } = result;
        if (!destination || source.index === destination.index) return;
        setAdicionais(prev => prev.map(grupo => {
            if (grupo._id !== grupoId) return grupo;
            const subs = Array.isArray(grupo.adicionais) ? [...grupo.adicionais] : [];
            const [movido] = subs.splice(source.index, 1);
            subs.splice(destination.index, 0, movido);
            const reordenados = subs.map((s, i) => ({ ...s, order: i + 1 }));
            updateAdicionaisItemOrder(grupoId, reordenados.map(s => s._id))
                .then(() => toast(t('order.updateSuccess', { defaultValue: 'Ordem atualizada!' }), { autoClose: 2000, type: 'success' }))
                .catch(() => toast(t('order.updateError', { defaultValue: 'Erro ao atualizar a ordem' }), { autoClose: 2500, type: 'error' }));
            return { ...grupo, adicionais: reordenados };
        }));
    }, [t]);
    const handleCadastro = () => setShowModalAddGroupAdd(true);

    const handleCadastroItemAdicional = (id_grupo, type) => {
        setIdGrupoToRegister(id_grupo);
        setTypeAdicional(type);
        setShowRegisterItemAdicional(!showRegisterItemAdicional);
    };

    const toggleOptions = (id) => {
        setVisibleDropdown(visibleDropdown === id ? null : id);
    };

    const handleEdit = (categoria) => {
        setCategoriaToEdit(categoria);
        setShowEditGrupoAdicionais(true);
    };

    const handleDuplicate = async (categoria) => {
        try {
            setLoading(true);
            const response = await duplicateGrupoAdicional(categoria._id);
            if (response.status === 201) {
                toast(response.data.msg, { autoClose: 5000, type: "success" });
                setRefresh(true);
            } else {
                toast(response.data.msg || t('toast.duplicateError'), { autoClose: 5000, type: "error" });
            }
        } catch (error) {
            toast(error.response?.data?.msg || t('toast.duplicateError'), { autoClose: 5000, type: "error" });
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = (categoriaToDelete) => {
        setConfirmOpen(true);
        setIdToDelete(categoriaToDelete._id);
        setShouldDelete(true);
    };

    const deleteReg = async () => {
        if (shouldDelete) {
            deleteGrupoAdicional(userID, idToDelete).then(cast => {
                if (cast.status === 201) {
                    toast(cast.data.msg, { autoClose: 5000, type: "success" });
                    setRefresh(true);
                } else {
                    toast(cast.data.msg, { autoClose: 5000, type: "error" });
                }
                setConfirmOpen(false);
            }).catch(err => {
                toast(err.response?.data?.msg || t('toast.updateError'), { autoClose: 5000, type: "error" });
                setConfirmOpen(false);
            });
        }
    };

    const handleEditClick = (id_grupo, adicional, typeGrupo = "simples") => {
        setItemAdicionalToEdit(adicional);
        setIdGrupoToEdit(id_grupo);
        setTypeGrupoToEdit(typeGrupo);
        setShowEditItemAdicional(!showEditItemAdicional);
    };

    const handleDeleteItem = (id_grupo, id) => {
        const data = { userID, id_subadicional: id, id_grupo };
        deleteItemAdicional(data).then(response => {
            if (response.status === 200) {
                toast(response.data.msg, { autoClose: 5000, type: "success" });
                setRefresh(true);
            } else {
                toast(response.data.msg, { autoClose: 5000, type: "error" });
            }
        }).catch(err => {
            toast(err.response?.data?.msg || t('toast.updateError'), { autoClose: 5000, type: "error" });
        });
    };

    const handleCheckboxChangeAdicional = async (idGrupo, itemID, titulo, price, id_item, currentOut) => {
        const newOutValue = !currentOut;
        setAdicionais(prev => prev.map(a => a._id === itemID ? { ...a, out: newOutValue } : a));
        try {
            const response = await updateItemAdicionalOut(userID, idGrupo, itemID, titulo, price, id_item, idEmpresa, newOutValue);
            if (response.status === 200) {
                toast(t('toast.updateSuccess'), { autoClose: 2500, type: 'success' });
                setRefresh(true);
            }
        } catch {
            toast(t('toast.updateError'), { autoClose: 2500, type: 'error' });
            setAdicionais(prev => prev.map(a => a._id === itemID ? { ...a, out: currentOut } : a));
        }
    };

    const handleCheckboxChangeAdicionalSalao = async (idGrupo, itemID, titulo, price, id_item, currentOut) => {
        const newOutValue = !currentOut;
        setAdicionais(prev => prev.map(a => a._id === itemID ? { ...a, out_salao: newOutValue } : a));
        try {
            const response = await updateItemAdicionalOutSalao(userID, idGrupo, itemID, titulo, price, id_item, idEmpresa, newOutValue);
            if (response.status === 200) {
                toast(t('toast.updateSuccess'), { autoClose: 2500, type: 'success' });
                setRefresh(true);
            }
        } catch {
            toast(t('toast.updateError'), { autoClose: 2500, type: 'error' });
            setAdicionais(prev => prev.map(a => a._id === itemID ? { ...a, out_salao: currentOut } : a));
        }
    };

    // ──────────── Render ────────────
    return (
        <>
            <PermissionGate permissions={['default']}>

                <ConfirmDialog
                    title={t('confirmDelete.title')}
                    open={confirmOpen}
                    setOpen={setConfirmOpen}
                    onConfirm={deleteReg}
                >
                    <div>
                        {t('confirmDelete.message')}
                        <br />
                        <span style={{ fontSize: 12 }}>{t('confirmDelete.warning')}</span>
                    </div>
                </ConfirmDialog>

                <ModalEditGrupoAdicionais
                    isOpen={showEditGrupoAdicionais}
                    onClose={() => setShowEditGrupoAdicionais(false)}
                    onSuccess={() => setRefresh(prev => !prev)}
                    grupo={categoriaToEdit}
                />

                <ModalEditItemAdicional
                    showEditItemAdicional={showEditItemAdicional}
                    setShowEditItemAdicional={setShowEditItemAdicional}
                    setRefresh={setRefresh}
                    itemAdicionalToEdit={itemAdicionalToEdit}
                    idGrupoToEdit={idGrupoToEdit}
                    typeGrupo={typeGrupoToEdit}
                />

                <ModalRegisterItemAdicional
                    showRegisterItemAdicional={showRegisterItemAdicional}
                    setShowRegisterItemAdicional={setShowRegisterItemAdicional}
                    setRefresh={setRefresh}
                    idGrupoToRegister={idGrupoToRegister}
                    typeAdicional={typeAdicional}
                />

                <ModalAddGroupAdicionais
                    showModalAddGroupAdd={showModalAddGroupAdd}
                    setShowModalAddGroupAdd={setShowModalAddGroupAdd}
                    selectDataAdicionais={selectDataAdicionais}
                    setselectDataAdicionais={setSelectDataAdicionais}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    item={null}
                    setTempAdicionais={setTempAdicionais}
                    context="list"
                />

                <PageContainer sidebar={sidebar}>
                    {loading && (
                        <div className="lc-loading-overlay">
                            <Loading type="spinningBubbles" color="rgb(49, 140, 213)" height={60} width={60} />
                        </div>
                    )}

                    <div className="lc-main-content w-100">
                        {/* ──── Header ──── */}
                        <div className="page-title-area" style={{ marginBottom: 24 }}>
                            <IoGridOutline style={{ fontSize: 28, color: 'rgb(49, 140, 213)' }} />
                            <h1 className="lc-page-title">{t('pageTitle')}</h1>
                        </div>

                        {/* ──── Toolbar ──── */}
                        <div className="lc-toolbar">
                            <div className="lc-search-wrapper">
                                <FiSearch className="lc-search-icon" />
                                <input
                                    className="lc-search-input"
                                    placeholder={t('searchPlaceholder')}
                                    value={filter}
                                    onChange={handleFilter}
                                />
                            </div>
                            <div className="lc-toolbar-actions">
                                <button className="lc-toolbar-btn lc-toolbar-btn--outline" onClick={() => navigate("/list-categoria")}>
                                    <AiOutlineMenu /> {t('manageMenu')}
                                </button>
                                <button className="lc-toolbar-btn lc-toolbar-btn--primary" onClick={handleCadastro}>
                                    <BsPlusCircle /> {t('newGroup')}
                                </button>
                                <button className="lc-toolbar-btn lc-toolbar-btn--outline" onClick={handleRefresh}>
                                    <SlRefresh /> {t('refresh')}
                                </button>
                            </div>
                        </div>

                        {/* ──── Groups List ──── */}
                        <div className="lc-categories-list">
                            {displayList.length === 0 && !loading && (
                                <div className="lc-empty-state">
                                    <span>{filter ? t('noResults') : t('noGroups')}</span>
                                </div>
                            )}

                            {displayList.map((grupo) => (
                                <div key={grupo._id} className="lc-category-card">
                                    {/* ──── Group Header ──── */}
                                    <div className="lc-category-header">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 14, flex: 1, minWidth: 0, flexWrap: 'wrap' }}>
                                            <span style={{
                                                fontSize: 11,
                                                fontWeight: 700,
                                                color: 'var(--lc-text-muted)',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.06em',
                                                textDecoration: 'underline',
                                                flexShrink: 0,
                                            }}>
                                                {grupo.type === "pizza" ? t('flavorGroup') : t('additionalGroup')}
                                            </span>
                                            <span className="lc-category-name" style={{ fontSize: 15 }}>{grupo.title}</span>
                                            <span className={`lc-badge ${grupo.mandatory ? 'lc-badge--required' : 'lc-badge--optional'}`}>
                                                {grupo.mandatory ? t('mandatory') : t('optional')}
                                            </span>
                                            <span className="lc-addon-range">
                                                {t('selectableRange', { min: grupo.min, max: grupo.max })}
                                            </span>
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
                                            <button
                                                className="lc-icon-btn lc-icon-btn-edit"
                                                onClick={() => handleEdit(grupo)}
                                                title={t('actions.edit')}
                                            >
                                                <FaRegEdit />
                                            </button>
                                            <button
                                                className="lc-icon-btn lc-icon-btn-edit"
                                                onClick={() => handleDuplicate(grupo)}
                                                title={t('actions.duplicate')}
                                            >
                                                <FiCopy />
                                            </button>
                                            <button
                                                className="lc-icon-btn lc-icon-btn-delete"
                                                onClick={() => handleDelete(grupo)}
                                                title={t('actions.delete')}
                                            >
                                                <FaRegTrashAlt />
                                            </button>
                                        </div>
                                    </div>

                                    {/* ──── Group Items ──── */}
                                    <div style={{ borderTop: '1px solid var(--lc-border-light, #f0f3f7)' }}>
                                        {grupo.adicionais && grupo.adicionais.length > 0 ? (
                                            <DragDropContext onDragEnd={(result) => handleDragEndAdicional(grupo._id, result)}>
                                                <Droppable droppableId={`grupo-adns-${grupo._id}`}>
                                                    {(dropProvided) => (
                                                        <div ref={dropProvided.innerRef} {...dropProvided.droppableProps}>
                                                            {grupo.adicionais.map((adicional, _idx) => (
                                                                <Draggable key={adicional._id} draggableId={String(adicional._id)} index={_idx}>
                                                                    {(dragProvided) => (
                                                                        <div ref={dragProvided.innerRef} {...dragProvided.draggableProps} className="lc-addon-item-row">
                                                                            <span {...dragProvided.dragHandleProps} title={t('order.dragToReorder', { defaultValue: 'Arraste para reordenar' })} style={{ cursor: 'grab', color: '#94a3b8', display: 'flex', alignItems: 'center', paddingRight: 8 }}>
                                                                                <AiOutlineMenu />
                                                                            </span>
                                                    {/* Left: image + name */}
                                                    <div className="lc-addon-subitem-info">
                                                        <SafeImage
                                                            src={adicional.image}
                                                            alt={adicional.title}
                                                            style={{ width: 44, height: 44, borderRadius: 8, objectFit: 'cover', border: '1px solid var(--lc-border-light)' }}
                                                            fallback={
                                                                <div className="lc-addon-subitem-placeholder">
                                                                    <MdFastfood />
                                                                </div>
                                                            }
                                                        />
                                                        <span>{adicional.title}</span>
                                                    </div>

                                                    {/* Right: controls */}
                                                    <div className="lc-addon-subitem-controls">
                                                        <div style={{ display: 'flex', gap: 16 }}>
                                                            <div className="lc-stock-toggle">
                                                                <span>{t('outDelivery')}</span>
                                                                <input
                                                                    type="checkbox"
                                                                    className="switch_1"
                                                                    checked={adicional.out}
                                                                    onChange={() => handleCheckboxChangeAdicional(
                                                                        grupo._id, adicional._id, adicional.title,
                                                                        adicional.price, adicional.id_adicional, adicional.out
                                                                    )}
                                                                />
                                                            </div>
                                                            <div className="lc-stock-toggle">
                                                                <span>{t('outSalon')}</span>
                                                                <input
                                                                    type="checkbox"
                                                                    className="switch_1"
                                                                    checked={adicional.out_salao}
                                                                    onChange={() => handleCheckboxChangeAdicionalSalao(
                                                                        grupo._id, adicional._id, adicional.title,
                                                                        adicional.price, adicional.id_adicional, adicional.out_salao
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="lc-addon-price-actions">
                                                            {adicional.price > 0 ? (
                                                                <span>{t('startingFrom', { price: formatPriceWithSymbol(adicional.price) })}</span>
                                                            ) : (
                                                                <span className="lc-addon-price--free">{t('freeAdditional')}</span>
                                                            )}
                                                            <div style={{ position: 'relative' }}>
                                                                <TbDotsVertical
                                                                    style={{ cursor: 'pointer', fontSize: 18 }}
                                                                    onClick={() => toggleOptions(adicional._id)}
                                                                />
                                                                {visibleDropdown === adicional._id && (
                                                                    <div className="lc-dropdown-menu" ref={dropdownRef}>
                                                                        <div
                                                                            className="lc-dropdown-item"
                                                                            onClick={() => handleEditClick(grupo._id, adicional, grupo.type)}
                                                                        >
                                                                            <FaRegEdit /> {t('actions.edit')}
                                                                        </div>
                                                                        <div
                                                                            className="lc-dropdown-item lc-dropdown-item--danger"
                                                                            onClick={() => handleDeleteItem(grupo._id, adicional._id)}
                                                                        >
                                                                            <FaRegTrashAlt /> {t('actions.delete')}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                            {dropProvided.placeholder}
                                                        </div>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>
                                        ) : (
                                            <div className="lc-empty-state" style={{ padding: '16px' }}>
                                                <span>{t('noItems')}</span>
                                            </div>
                                        )}

                                        {/* Register button */}
                                        <button
                                            type="button"
                                            className="lc-add-addon-btn"
                                            onClick={() => handleCadastroItemAdicional(grupo._id, grupo.type)}
                                        >
                                            <BsPlusCircle />
                                            {grupo.type === "pizza" ? t('registerFlavor') : t('registerAdditional')}
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </PageContainer>

            </PermissionGate>
        </>
    );
};

export default ListAdicional;
